// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MCN90","left":"styles_left__1Ztyu"};